/** @fileoverview Short error message shown inside an app block, read out by screen readers. */

import type { ReactNode } from 'react';
import { cn } from 'cn';
import { CircleAlert } from 'lucide-react';

/**
 * Shows a short error message: a line of small red text, or a red box with an icon for an
 * error that stops a whole form.
 * @param props the message, the look and an optional class name for spacing
 */
export default function InlineAlert({
  children,
  className,
  variant = 'line',
}: {
  children: ReactNode;
  className?: string;
  variant?: 'line' | 'box';
}) {
  if (variant === 'line') {
    return (
      <p className={cn('type-caption text-destructive', className)} role="alert">
        {children}
      </p>
    );
  }
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/5 px-3 py-2.5 type-body text-destructive',
        className
      )}
      role="alert"
    >
      <CircleAlert className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
